import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const copyButton = style({
  minHeight: space.s24,
  padding: `${space.s2}px ${space.s6}px`,
  ...typography['labelSm'],
});
